<script setup lang="ts">

</script>

<template>
<div class="flex flex-col w-full font-['Sora'] font-medium text-[20px] text-[var(--m-dark)]">
  <slot />
  <div class="flex-auto w-14 border-b-2 transition duration-500 ease-in-out border-[var(--m-primary-base)]" />
</div>
</template>

<style scoped lang="scss">

</style>